import { ViewListData } from "@/context/ViewListContext";
import useUiStore from "@/store/ui.state";
import { useTranslation } from "@vixi/localization";
import { useCallback } from "react";
import { PaginationWithDelete } from "../pagination/with-delete";

type ConversationPaginationProps = ViewListData & {
  visibleItems: number;
  onDeleteItem: (index: number) => void;
};

function ConversationPagination({ onDeleteItem, ...props }: ConversationPaginationProps) {
  const { t } = useTranslation();
  const { showConfirmDialog } = useUiStore();

  const { mode } = useUiStore((state) => state.courseEditor);
  const isDisabled = mode === "view";

  const handleDelete = useCallback(
    (i: number) => {
      if (i === props.stepsCount - 1) props.prevStep();
      onDeleteItem(i);
    },
    [onDeleteItem],
  );

  const onDeleteClicked = useCallback(
    (i: number, e: React.MouseEvent<HTMLButtonElement>) => {
      if (e.shiftKey) {
        handleDelete(i);
        return;
      }

      showConfirmDialog({
        title: "Confirmation.DeleteSentence.Title",
        description: (
          <p className="text-foreground-secondary fs-12">
            {t("Confirmation.DeleteSentence.Description")}?
            <br />
            <em>{t("Confirmation.SkipByHoldingShift")}</em>
          </p>
        ),
        onConfirm: () => handleDelete(i),
      });
    },
    [handleDelete],
  );

  return (
    <div className="my-1.5 box-border flex w-full justify-between px-2.5">
      <PaginationWithDelete
        visiblePages={props.visibleItems}
        activePage={props.activeStep}
        onDeleteItem={onDeleteClicked}
        totalPages={props.stepsCount}
        deleteDisabled={isDisabled}
        onGoToPage={props.goToStep}
      />
    </div>
  );
}

export { ConversationPagination };
export type { ConversationPaginationProps };
